module.exports = "/_next/static/images/19b4027d5c2338300737417bdb29477b-iPhone12pro_2.png";